import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-creole-section',
  templateUrl: './creole-section.component.html',
  styleUrls: ['./creole-section.component.scss'],
})
export class CreoleSectionComponent {
  creoletextImageUrl = `${environment.cdnBaseURL}public/images/creoletext.png`;
  newcreolebannerbgImageUrl = `${environment.cdnBaseURL}public/images/newcreolebannerbg.jpg`;

  constructor(public routes: ActivatedRoute, public router: Router) {}

  btnClick(): void {
    this.router.navigateByUrl('/culture/creole-rendezvous');
  }
}
